// Canonical schema for the Pre-Treatment Medical Questionnaire on the
// Customer Profile tab. Kept in its own module so both the profile editor
// and (future) intake forms / receipt printouts can share the same list.
//
// Questions are stored on `customer.medical_questionnaire[key]` as
//   { answer: "yes" | "no" | null, note: string }
// Missing keys mean "not asked yet"; the operator can fill them in over
// multiple visits.

export const MEDICAL_QUESTIONS = [
  { key: "known_allergies",       label: "Known Allergies" },
  { key: "heart_problems",        label: "Heart problems" },
  { key: "high_blood_pressure",   label: "High Blood Pressure" },
  { key: "diabetes",              label: "Diabetes" },
  { key: "stroke",                label: "Stroke" },
  { key: "bells_palsy",           label: "Bell's palsy (or other facial weakness)" },
  { key: "liver_kidney_disease",  label: "Liver or Kidney disease" },
  { key: "asthma",                label: "Asthma" },
  { key: "keloid",                label: "Keloid" },
  { key: "skin_problems",         label: "Skin problems e.g. Herpes (cold sores), acne, psoriasis, dermatitis, eczema" },
  { key: "blood_disorders",       label: "Blood disorders e.g. Bleed or bruise easily" },
  { key: "current_infection",     label: "Current infection or illness" },
  { key: "recent_surgery",        label: "Recent surgery (incl dental work)" },
  { key: "drug_treatment",        label: "Drug Treatment/Medication (current or recent)" },
  { key: "previous_cosmetic",     label: "Any previous cosmetic, injectable treatments. If so, when, where, which product, any adverse/allergic reaction" },
  { key: "previous_surgery",      label: "Previous Surgery" },
  { key: "pregnant_breastfeeding", label: "Pregnant/Breast Feeding" },
  { key: "smoke",                 label: "Do you smoke" },
  { key: "alcohol",               label: "Do you drink alcohol" },
];

// Canonical cosmetic-allergy ingredient list — 11 checkboxes rendered as a
// 3-column grid on the Profile tab.
export const COSMETIC_INGREDIENTS = [
  "Aloe Vera",
  "Benzoyl Peroxide",
  "Progesterone",
  "Cortisone",
  "Vit. E Topical",
  "Retin A/Retinol",
  "Sulphur",
  "Hydroquinone",
  "Glycolic",
  "Vit. C Topical",
  "Sunscreen",
];
